import { render } from "./Kunden.vue?vue&type=template&id=9d5fc0fe&scoped=true"
import script from "./Kunden.vue?vue&type=script&lang=js"
export * from "./Kunden.vue?vue&type=script&lang=js"

import "./Kunden.vue?vue&type=style&index=0&id=9d5fc0fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d5fc0fe"]])

export default __exports__